module.exports = __webpack_public_path__ + "img/avatar_group.09c28ede.png";